import store from '@/store';
import { DVB_TYPE, SERVICE_TYPE, TV_STATUS } from '.';
import Device from '../Device';

console.log("TIZEN TV b2bapis (window):", window.hasB2bapis);
console.log("TIZEN TV webapis (window):", window.hasWebapis);

export default class Tizen {
  static get broadcast() {
    if (window.b2bapis && window.tizenVersion <= "6.0") return window.b2bapis.b2bbroadcast;
    if (window.webapis && window.tizenVersion >= "6.5") return window.webapis.broadcast;
    return undefined;
  }

  static get broadcastManager() {
    if (window.b2bapis) return window.b2bapis.broadcastManager;
    return undefined;
  }

  static get b2bControl() {
    if (window.b2bapis) return window.b2bapis.b2bcontrol;
    if (window.webapis) return window.webapis.systemcontrol;
    return undefined;
  }

  static get b2bPower() {
    if (window.b2bapis) return window.b2bapis.b2bpower;
    if (window.webapis) return window.webapis.remotepower;
    return undefined;
  }

  static get avPlay() {
    if (!window.webapis) return undefined;
    return window.webapis.avplay;
  }

  static get getListener() {
    return {
      onbufferingstart: function() {
        console.log('buffering start');
        // this.tvStatus = 'buffering start';
      },
      onbufferingprogress: function(percent) {
        console.log('buffering progress..');
        // this.tvStatus = 'buffering progress';
      },
      onbufferingcomplete: function() {
        console.log('buffering complete..');
        // this.tvStatus = 'buffering complete';
      },
      oncurrentplaytime: function(currentTime) {
        //$("#test").prepend("currentTime=="+currentTime);
        // console.log('current playtime :: ' + currentTime);
        // this.tvStatus = 'current playtime :: ' + currentTime;
      },
      onevent: function(eventType, eventData) {
        // $('#test').prepend(
        //   '<p>onevent ' + eventType + ' data ' + eventData + '</p>'
        // );
        // this.tvStatus = 'Event Time: ' + eventType + ', Data: ' + eventData;
        console.log('onevent ' + eventType + ' data ' + eventData);
      },
      onstreamcompleted: function() {
        // $('#test').prepend('<p>stream completed..</p>');
        // this.tvStatus = 'stream completed ...';
        console.log('stream completed..');
      },
      onerror: function(eventType) {
        // this.tvStatus = 'error has occured.. ' + eventType;
        // $('#test').prepend('<p>error has occured..' + eventType + '</p>');
        console.log('error has occured..', eventType);
      },
      onsubtitlechange: function(duration, text, data3, data4) {
        // this.tvStatus = 'subtitle changed..' + duration + text;
        // $('#test').prepend('<p>subtitle changed..</p>');
        console.log('subtitle changed..', duration, text);
      },
      ondrmevent: function(drmEvent, drmData) {
        console.log('on drm event..');
      },
    };
  }

  static setChannel(channel, type = SERVICE_TYPE.TV, isNew) {
    if (!this.avPlay) {
      console.log(' -- [ERROR]: Missing WEBAPIS.AVPLAY');
      return;
    }
    //console.log('TV.setChannel', channel);
    if (type === SERVICE_TYPE.TV) this.handleTVChannel(channel);
    if (type === SERVICE_TYPE.INFO) this.handleTVChannel(channel);
    if (type === SERVICE_TYPE.RADIO) this.handleRadioChannel(channel);
  }

  // Videoflaeche auf ein Rechteck setzen (Prozent) - Grundlage der Live-Vorschau.
  //
  // Auf Tizen laeuft das ueber tvwindow.show mit neuem Rechteck; die Signatur ist
  // (onSuccess, onFailure, rect, plane, zOrder). Ohne Callbacks wird nur die
  // Groesse geaendert, ohne neu zu tunen.
  //
  // Anders als auf LG ist der Zustand hier weniger heikel: jeder Tune-Pfad
  // uebergibt sein Rechteck explizit (100%), ein verkleinertes Fenster wirkt sich
  // also nicht auf den TV-Player aus. resetVideoRect() gibt es trotzdem, damit
  // die Vorschau plattformunabhaengig aufgeraeumt werden kann.
  static setVideoRect(rect) {
    const r = rect || {};
    const css = [
      (r.x || 0) + '%',
      (r.y || 0) + '%',
      (r.width === undefined ? 100 : r.width) + '%',
      (r.height === undefined ? 100 : r.height) + '%',
    ];
    try {
      Device.apis.tvwindow.show(null, null, css, 'MAIN', 'BEHIND');
      console.log('[TV/Tizen] tvwindow rect', css);
      return true;
    } catch (e) {
      console.log('[TV/Tizen] tvwindow rect error', e);
      return false;
    }
  }

  static resetVideoRect() {
    return Tizen.setVideoRect({ x: 0, y: 0, width: 100, height: 100 });
  }

  static clearChannel() {
    //console.log("===========IP-clearChannel===========");
    try {
      this.avPlay.stop();
      this.avPlay.close();
      Device.apis.tvwindow.hide(this.callbackSuccess, this.callbackError);
    } catch (e) {
      console.log('could not close');
    }
    return Promise.resolve();
  }

  static clearChannelDVB() {
    //let tuneOption = new tizen.BroadcastManager.DirectTuneOption();
    //let tuneOptions = new this.broadcast.DirectTuneOption();
    //tuneOption.setBroadcast('');
    //console.log("===========DVB-clearChannelDVB===========");
    //const tuneOptions = {};
    //console.log("===========DVB-clearChannelDVB1===========tuneOptions=>", tuneOptions);

    /*const channel_params = {
      broadcastStandard: 'DVB',
      frequency: '400000000',
      bandwidth: '8Mhz',
      serviceId: '0',
      channelType: 'CDTV',
      modulationType: 'QAM256',
      symbolRate: '0',
      major: 1,
      satelliteId: 'ASTRA_19_2E',
      polarization: 'POL_HL'
    };*/
    const channel_params = {
      "dvb_type": "c",
      "url": "",
      "name": "",
      "serviceId": 99999,
      "buildingId": 1,
      "originalNetworkId": 0,
      "transportStreamId": 0,
      "gateway_id": "",
      "serviceType": "tv",
      "position": 0,
      "price": "0.00",
      "frequency": "50000000",
      "symbolRate": "6900",
      "tags": [],
      "frequencyInKhz": "50000",
      "packages": [],
      "epgChannelId": 0,
      "id": "1"
    };

    try {
      console.log('===========DVB-clearChannelDVB-TRY===========channel_params=>', channel_params);
      /*this.broadcast.tuneDirect(
        tuneOptions,
        this.callbackSuccess,
        this.callbackError
              );*/
      this.tuneChannel_DVB(channel_params);
      Device.apis.tvwindow.hide(this.callbackSuccess, this.callbackError);
    } catch (e) {
      console.log('could not close DVB');
      // e, nicht error: der Parameter heisst e. Mit error warf der catch-Block
      // selbst einen ReferenceError - der Aufrufer bekam also einen
      // ReferenceError statt der Meldung ueber den fehlgeschlagenen Tune.
      store.dispatch('notification/error', {
        title: 'Tune Direct zero',
        message: (e && e.message) || String(e),
      });
    }
    return Promise.resolve();
  }
  
  static playChannelDVB() {
    //let tuneOption = new tizen.BroadcastManager.DirectTuneOption();
    //let tuneOptions = new this.broadcast.DirectTuneOption();
    //tuneOption.setBroadcast('');
    console.log("===========DVB-playChannelDVB===========");
    //const tuneOptions = {};
    //console.log("===========DVB-clearChannelDVB1===========tuneOptions=>", tuneOptions);

    /*const channel_params = {
      broadcastStandard: 'DVB',
      frequency: '400000000',
      bandwidth: '8Mhz',
      serviceId: '0',
      channelType: 'CDTV',
      modulationType: 'QAM256',
      symbolRate: '0',
      major: 1,
      satelliteId: 'ASTRA_19_2E',
      polarization: 'POL_HL'
    };*/
    const channel_params = {
      "dvb_type": "c",
      "url": "",
      "name": "",
      "serviceId": 0,
      "buildingId": 0,
      "originalNetworkId": 0,
      "transportStreamId": 0,
      "gateway_id": "",
      "serviceType": "tv",
      "position": 0,
      "price": "0.00",
      "frequency": "200000000",
      "symbolRate": "0",
      "tags": [],
      "frequencyInKhz": "200000",
      "packages": [
          "tv-#1"
      ],
      "epgChannelId": 0,
      "id": ""
    };

    try {
      console.log('===========DVB-playChannelDVB-TRY===========channel_params=>', channel_params);
      /*this.broadcast.tuneDirect(
        tuneOptions,
        this.callbackSuccess,
        this.callbackError
      );*/
      Device.apis.tvwindow.hide(this.callbackSuccess, this.callbackError);
      //this.tuneChannel_DVB(channel_params);
    } catch (e) {
      console.log('could not close DVB');
      // e, nicht error: der Parameter heisst e. Mit error warf der catch-Block
      // selbst einen ReferenceError - der Aufrufer bekam also einen
      // ReferenceError statt der Meldung ueber den fehlgeschlagenen Tune.
      store.dispatch('notification/error', {
        title: 'Tune Direct zero',
        message: (e && e.message) || String(e),
      });
    }
    return Promise.resolve();
  }

  static removePlayer(channel) {
    //store.dispatch('notification/new', {
    //  title: 'REMOVE CHANNEL',
    //  message: 'Channel-Typ: '.channel.dvb_type,
    //});
    //console.log("===========removePlayer===========channel=>", channel);
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        store.dispatch('notification/new', {
          title: 'REMOVE CHANNEL IP',
          message: channel,
        });
        this.clearChannel();
        break;
      case DVB_TYPE.T:
      case DVB_TYPE.C:
      case DVB_TYPE.S:
        store.dispatch('notification/new', {
          title: 'REMOVE CHANNEL DVB',
          message: channel,
        });
        if(window.tizenVersion == '4.0') this.clearChannel();
        this.clearChannelDVB();
        break;
      default:
        //console.log("===========removePlayer-DEDAULT===========channel=>", channel);
        store.dispatch('notification/new', {
          title: 'REMOVE CHANNEL IP/DVB',
          message: channel,
        });
        this.clearChannel();
        this.clearChannelDVB();
    }
    
    //this.clearChannel();
    //this.clearChannelDVB(channel);
  }

  static handleTVChannel(channel) {
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        this.tuneChannel_IP(channel);
        break;
      case DVB_TYPE.T:
      case DVB_TYPE.C:
      case DVB_TYPE.S:
        this.tuneChannel_DVB(channel);
        store.dispatch('notification/new', { title: 'Tune Direct Channel' });
        break;
      default:
        console.log('CHANNEL TYPE NOT SUPPORTED');
    }
  }

  static handleRadioChannel(channel) {
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        this.tuneChannel_IP(channel);
        break;
      case DVB_TYPE.T:
      case DVB_TYPE.C:
      case DVB_TYPE.S:
        this.tuneChannel_DVB(channel);
        store.dispatch('notification/new', { title: 'Tune Direct Channel' });
        break;
      default:
        console.log('CHANNEL TYPE NOT SUPPORTED');
    }
  }

  static async tuneChannel_IP(data) {
    this.clearChannel();

    const channel = {
      ...data,
      url: data.url.replace('igmp://', 'udp://'),
    };

    try {
      console.log(' ------------------------------------------------ [IP TUNE OPTIONS]: ', channel);
      this.avPlay.open(channel.url);
      this.avPlay.setDisplayRect(0, 0, 1920, 1080);
      this.avPlay.setListener(this.getListener);
      this.avPlay.prepare();
      this.avPlay.play();
      //console.log(' -- [TRY]: selecting channel: ', channel);
      store.dispatch('tv/setStatus', TV_STATUS.LOADED);
    } catch (e) {
      console.log(' -- [ERROR]: while selecting ip channel: ', e);
      store.dispatch('notification/error', {
        title: 'TuneChannel - IP',
        message: 'Could not tune IP Channel',
      });
    }
    return Promise.resolve();
  }

  static tuneChannel_DVB(channel) {
    if(window.tizenVersion == '4.0') this.clearChannel();
    //if(window.tizenVersion == '4.0') this.playChannelDVB();

    const tuneChannel = () => {
      const tuneOptions = {
        broadcastStandard: channel.broadcastStandard || 'DVB',
        frequency: parseInt(channel.frequency) / 1000,
        programNumber: parseInt(channel.serviceId),
      };

      switch (channel.dvb_type) {
        case DVB_TYPE.C:
          tuneOptions.channelType = channel.channelType || 'CDTV';
          tuneOptions.modulationType = channel.modulationType || 'QAM256';
          tuneOptions.symbolRate = parseInt(channel.symbolRate);
          tuneOptions.bandwidth = channel.bandwidth || '8Mhz';
          //tuneOptions.modulationType = 'QAM256';
          //tuneOptions.symbolRate = 6900;
          //tuneOptions.bandwidth = '8Mhz';
          tuneOptions.major = channel.major || 1;
          break;
        case DVB_TYPE.T:
          tuneOptions.channelType = channel.channelType || 'DTV';
          tuneOptions.modulationType = channel.modulationType || '8PSK';//'QAM16';
          tuneOptions.bandwidth = channel.bandwidth || '8Mhz';
          //tuneOptions.modulationType = 'QAM16';//'8PSK';
          //tuneOptions.bandwidth = '8Mhz';
          tuneOptions.major = channel.major || 1;
          break;
        case DVB_TYPE.S:
          tuneOptions.channelType = channel.channelType || 'SDTV';
          tuneOptions.modulationType = channel.modulationType || 'QPSK';
          tuneOptions.satelliteId = channel.satelliteId || 'ASTRA_19_2E';
          tuneOptions.polarization = channel.polarization || 'POL_HL';
      }

      try {
        console.log(' ------------------------------------------------ [DVB TUNE OPTIONS]: ', tuneOptions, channel);
        //this.broadcast.tuneDirect(tuneOptions, this.callbackSuccess, this.callbackError);
        if(window.tizenVersion >= '6.5') {
          window.webapis.broadcast.tuneDirect(tuneOptions, this.callbackSuccess, this.callbackError);
        } else {
          this.broadcast.tuneDirect(tuneOptions, this.callbackSuccess, this.callbackError);
        }
      } catch (error) {
        console.log(' -- [ERROR]: Could not tune dvb direct');
        store.dispatch('notification/error', {
          title: 'Tune Direct',
          message: error,
        });
      }
    };
    
    //TODO: this.$store.state.device.resHeight
    //const resHeight = Device.resolutionHeight;
    //const resWidth = Device.resolutionWidth;
    //console.log("===========================RES", resHeight, resWidth);
    Device.apis.tvwindow.show(
      tuneChannel,
      null,
      ['0px', '0px', '100%', '100%'],
      'MAIN',
      'BEHIND'
    );

    //if(window.tizenVersion == '4.0') this.playChannelDVB();
  }

  static get streamInfo() {
    try {
      const info = this.avPlay.getCurrentStreamInfo();
      return info;
    } catch (e) {
      console.log('ERROR: Could not receive any informations from stream: ', e);
    }
    return [];
  }

  static callbackSuccess(name, context) {
    console.log('CALLBACK_SUCCESS: ', name, ' with context: ', context);
  }
  static callbackError(name, context) {
    console.log('CALLBACK_ERROR: ', name, ' with context: ', context);
  }
  static callbackChange(val) {
    console.log('changed function.' + JSON.stringify(val));
  }

  static PowerState() {
    try {
      const PowerState = this.b2bPower.getPowerState();
      // console.log('[getPowerState] call syncFunction type: ' + PowerState);
      store.dispatch('notification/new', {
        title: 'Power State',
        message: PowerState,
      });
    } catch (e) {
      store.dispatch('notification/new', {
        title: e.name,
        message: e.message,
      });
      console.log(
        '[getPowerState] call syncFunction exception [' +
          e.code +
          '] name: ' +
          e.name +
          ' message: ' +
          e.message
      );
    }
  }

  static turnOff() {
    const cbSuccess = () => this.callbackSuccess('turnOff');
    const cbError = () => this.callbackError('turnOff');
    if(window.b2bapis) {
      console.log('=================================================Turning off TV - b2bControl', this.b2bControl);
      this.b2bControl.setExternalControl("display_control", "off", cbSuccess, cbError);
    } else if(window.webapis) {
      console.log('=================================================Turning off TV - webapis.remotepower');
      window.webapis.remotepower.powerOff();
    }
  }
  static turnOn() {
    const cbSuccess = () => this.callbackSuccess('turnOn');
    const cbError = (err) => this.callbackError('turnOn', err);
    if(window.b2bapis) this.b2bPower.setPowerOn(cbSuccess, cbError);
    else if(window.webapis) this.b2bPower.powerOn(cbSuccess, cbError);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/TV/Tizen.js